import AppConstants from 'constants/AppConstants';

export function setScrollDirections(directions: {
  hasScrolledUp: boolean;
  hasScrolledDown: boolean;
}): BaseTockAction {
  return {
    type: AppConstants.SCROLL_SET,
    payload: directions,
  };
}
